export const snakeToPascal = (string) => {
  if (typeof string !== 'string') return ''

  return string
    .split('_')
    .map((str) => {
      return upperFirst(str.split('/').map(upperFirst).join('/'))
    })
    .join('')
}

export const upperFirst = (string) => {
  if (typeof string !== 'string') return ''
  return string.slice(0, 1).toUpperCase() + string.slice(1, string.length)
}

export const startsWithHttp = (string) => {
  if (typeof string !== 'string') return false
  const link = string.toLowerCase()
  if (link.includes('tel:') || link.includes('mailto:') || link.includes('api.whatsapp:') || link.includes('wa.me:'))
    return true
  return link.substring(0, 4) === 'http'
}

export const toUpperCase = (string) => {
  if (typeof string !== 'string') return ''
  return string.toUpperCase()
}

export const toLowerCase = (string) => {
  if (typeof string !== 'string') return ''
  return string.toLowerCase()
}

export const removeSpecialChars = (string) => {
  if (typeof string !== 'string') return ''
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export const slugify = (string) => {
  if (typeof string !== 'string') return ''
  return removeSpecialChars(string).trim().replace(/ /g, '-').replace(/\//g, '-').toLowerCase()
}

export const generateId = (suffix, prefix) => {
  if (suffix && typeof suffix !== 'string') return ''
  if (prefix && typeof prefix !== 'string') return ''
  const time = new Date().getTime()
  return `${slugify(prefix)}${time}${slugify(suffix)}`
}

export const cpfMask = (value) => {
  if (typeof value !== 'string') return ''
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export const cnpjMask = (value) => {
  if (typeof value !== 'string') return ''
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{4})(\d{1,2})/, '$1/$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export const cnpjAlphaNormalize = (value) => {
  // garante que só processa string
  if (typeof value !== 'string') return false

  return value
    // separa acentos das letras (ex: Á → A + ´)
    .normalize('NFD')
    // remove os acentos (mantém só a letra base)
    .replace(/[\u0300-\u036f]/g, '')
    // transforma tudo em maiúsculo (padronização)
    .toUpperCase()
    // remove qualquer coisa que não seja letra ou número
    .replace(/[^A-Z0-9]/g, '')
    // garante tamanho máximo de 14 caracteres
    .slice(0, 14)
}

export const isCnpjAlphaFormat = (value) => {
  if (typeof value !== 'string') return false

  // normaliza antes de validar
  const v = cnpjAlphaNormalize(value)

  /*  formato esperado:
    12 primeiros → letras ou números
    últimos 2 → obrigatoriamente números (dígitos verificadores)
  */
  return /^[A-Z0-9]{12}[0-9]{2}$/.test(v)
}

const cnpjAlphaCharToValue = (ch) => {
  // se for número ('0' até '9')
  if (ch >= '0' && ch <= '9') {
    // converte char → número (ex: '5' → 5)
    return ch.charCodeAt(0) - 48
  }

  // se for letra ('A' até 'Z')
  if (ch >= 'A' && ch <= 'Z') {
    // converte para base36: A=10, B=11, ..., Z=35
    return ch.charCodeAt(0) - 55
  }

  // qualquer outra coisa é inválida
  return NaN
}

// módulo 11 com pesos cíclicos de 2 até 9 (da direita pra esquerda)
const cnpjAlphaCalcDV = (values) => {
  let weight = 2 // peso inicial
  let sum = 0    // acumulador

  // percorre da direita para esquerda
  for (let i = values.length - 1; i >= 0; i--) {
    sum += values[i] * weight

    // incrementa peso: 2 → 3 → ... → 9 → volta pra 2
    weight = weight === 9 ? 2 : weight + 1
  }

  const mod = sum % 11

  // regra do módulo 11: se resto < 2 → DV = 0, senão → DV = 11 - resto
  return mod < 2 ? 0 : 11 - mod
}

export const isCnpjAlphaValid = (value) => {
  // só aceita string
  if (typeof value !== 'string') return false

  // normaliza entrada (remove máscara, acento, etc)
  const v = cnpjAlphaNormalize(value)

  // valida formato básico antes de calcular DV
  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(v)) return false

  // separa base (12 primeiros) e dígitos verificadores (2 últimos)
  const base = v.slice(0, 12)
  const dv1Expected = Number(v[12])
  const dv2Expected = Number(v[13])

  // converte cada caractere em número
  const valuesBase = Array.from(base).map(cnpjAlphaCharToValue)

  // se algum caractere for inválido → falha
  if (valuesBase.some((n) => Number.isNaN(n))) return false

  // calcula os dígitos verificadores
  const dv1 = cnpjAlphaCalcDV(valuesBase)
  const dv2 = cnpjAlphaCalcDV([...valuesBase, dv1])

  // compara com os dígitos informados
  return dv1 === dv1Expected && dv2 === dv2Expected
}

export const cepMask = (value) => {
  if (typeof value !== 'string') return ''
  return value
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/\.(\d{3})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export const phoneWithDDDMask = (value, maxLength = 15, isCellphone = false) => {
  if (typeof value !== 'string') return ''
  if (value.length <= maxLength) {
    if (isCellphone) {
      return value.replace(/\D/g, '').replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3')
    } else {
      return value.replace(/\D/g, '').replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3')
    }
  } else return false
}

export const phoneMask = (value) => {
  if (typeof value !== 'string') return ''
  if (value.length >= 9) {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1')
  } else {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1')
  }
}

export const codeMask = (value) => {
  if (typeof value !== 'string') return ''
  return value
    .replace(/\D/g, '')
    .replace(/^(\d{1})(\d)/, '$1 $2')
    .replace(/(\d{3})(\d)/, '$1 $2')
    .replace(/(\d{12})(\d)/, '$1 $2')
}

export const dateMask = (value) => {
  if (typeof value !== 'string') return ''
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\/\d{4})\d+?$/, '$1')
}

export const hideString = (value) => {
  if (typeof value !== 'string') return ''
  let str = value.charAt(0)
  for (var i = 1; i < value.length - 1; i++) {
    str += '*'
  }
  str += value.charAt(value.length - 1)
  return str
}

export const hideEmail = (value) => {
  if (typeof value !== 'string') return ''
  let parts = value.split('@')
  let email = hideString(parts[0]) + '@'
  parts = parts[1].split('.')
  email += hideString(parts[0]) + '.' + parts[1] + (parts[2] ? '.' + parts[2] : '')
  return email
}

export const numberMask = (value, limit = 99) => {
  if (typeof value !== 'string') return ''
  return value.replace(/\D/g, '').substr(0, limit) // substitui qualquer caracter que nao seja numero por nada
}

export const accentuationMask = (value) => {
  if (typeof value !== 'string') return ''
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export default {
  snakeToPascal,
  upperFirst,
  startsWithHttp,
  toUpperCase,
  toLowerCase,
  slugify,
  removeSpecialChars,
  generateId,
}
